import { render, staticRenderFns } from "./AnalysisLocalizationsCard.vue?vue&type=template&id=c4c93236&scoped=true&"
import script from "./AnalysisLocalizationsCard.vue?vue&type=script&lang=js&"
export * from "./AnalysisLocalizationsCard.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisLocalizationsCard.vue?vue&type=style&index=0&id=c4c93236&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c93236",
  null
  
)

export default component.exports